import { render, staticRenderFns } from "./EXTooltip.vue?vue&type=template&id=1972640e"
import script from "./EXTooltip.vue?vue&type=script&lang=js"
export * from "./EXTooltip.vue?vue&type=script&lang=js"
import style0 from "./EXTooltip.vue?vue&type=style&index=0&id=1972640e&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports